{
	"isGrouped": "There are products with no registered cost",
	"isNotGrouped": "Cost not registered",
	"na": "N/A"
}
